import clsx from 'clsx'
import { useRef } from 'react'
import useToggle from 'src/common/hooks/helpers/useToggle'
import Icon from 'src/common/ui-kit/Icon/Icon'
import IconButton from 'src/common/ui-kit/IconButton'
import Menu from 'src/common/ui-kit/Menu/Menu'
import { navbarRoutes } from 'src/routes'
import NavBarLink from './NavBarLink'

export interface NavBarProps {
  className?: string
}

const NavBarMobile: React.FC<NavBarProps> = ({ className }) => {
  const { isOn, toggle, off } = useToggle()
  const buttonRef = useRef(null)

  const handleCloseMenu = () => off()
  const hadnleOpenMenu = () => toggle()

  return (
    <>
      <IconButton
        ref={buttonRef}
        onClick={hadnleOpenMenu}
        className={className}
      >
        <Icon name='hamburger' size='20px' />
      </IconButton>
      <Menu
        anchorEl={buttonRef.current}
        buttonRef={buttonRef}
        open={isOn}
        onClose={handleCloseMenu}
        className='py-3 px-4 w-32'
      >
        <div className={clsx('flex flex-col gap-2', className)}>
          {navbarRoutes.map(({ path, name, activePaths }) => (
            <NavBarLink
              onClick={off}
              key={path}
              path={path}
              name={name}
              activePaths={activePaths}
            />
          ))}
        </div>
      </Menu>
    </>
  )
}

export default NavBarMobile
